import {useState, useEffect} from 'react';
import styles from './NavBar.module.scss';
import logo from '../../Media/logo UNSTPB negru.png';
import { Link, useLocation } from 'react-router-dom';
import CustomButton from '../../CustomComponents/CustomButton';
import { theme } from '../../theme';
import {isUserLogged, useUserData } from '../../utils/utilFunctions';
import NavBarMobile from './NavBarMobile';
import { logout } from '../../utils/utilFunctions';
import { useTranslation } from "react-i18next";
import { Select, Tooltip} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { getCountNotificationsNumber } from '../../Requests/notification-requests';
import HeadersLinks from "./HeadersLinks";
import {useQuery} from "react-query";

const { Option } = Select;

const NavBar = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const [state, setState] = useState({
    mounted: false,
  });

  const { data: userData } = useUserData();

  const { data: notificationsNumber } = useQuery(['getNotificationsNumber'],
    () => {
      if(isUserLogged())
        return getCountNotificationsNumber();
    });

  useEffect(() => {
    if (!state.mounted) {
      setState((prevState) => ({
        ...prevState,
        mounted: true,
      }));
    }
  }, [state.mounted]);

  return (
    <div className={styles.headerContainer}>
      <div className={styles.firstChild}>
        <Link to="/">
          <img
            alt="logo"
            src={logo}
            className={styles.logo}
          />
        </Link>
      </div>
      <div className={styles.secondChild}>
        <HeadersLinks/>
      </div>
      <div className={styles.thirdChild}>
          {isUserLogged() && userData?.name ?
            <span className={styles.userName}>{userData.name}</span>
          : null}

          {/* <Tooltip title={t('footer.frequentQuestions')}>
              <Link
                to='/intrebari-frecvente'
                style={{
                  fontWeight: location.pathname === "/intrebari-frecvente" ? "bold" : "normal",
                  color: location.pathname === "/intrebari-frecvente" ? theme.primaryColor : "black",
                  margin: '0 5% 0 0',
                  padding: '5px'
                }}
              >
                <FontAwesomeIcon icon={solid('question-circle')} style={{fontSize: theme.headerSizeIcons }}/>
              </Link>
          </Tooltip> */}

          <Tooltip title="Suport">
            <a href='https://support.upb.ro/' target={'_blank'}>
                <FontAwesomeIcon icon={solid('headset')} style={{fontSize: theme.headerSizeIcons }}/>
            </a>
          </Tooltip>


          {/* {isUserLogged() ?
            <Tooltip title="Notificări">
              <Badge count={notificationsNumber} size='small' style={{ margin: '0 0 0 0' }}>
                <Link 
                  to="/notificari"
                  title={t('header.notifications')}
                  style={{ 
                    fontWeight: location.pathname === "/notificari" ? "bold" : "normal", 
                    color: location.pathname === "/notificari" ? theme.primaryColor : "black",
                    margin: '0 0 0 0',
                    padding: '5px'
                  }}
                >
                  <FontAwesomeIcon icon={solid('bell')} style={{fontSize: theme.headerSizeIcons }}/>
                </Link>
              </Badge>
            </Tooltip>
          : null} */}


          {!isUserLogged() ? 
            <CustomButton
              backgroundcolor={theme.primaryColor}
              textcolor={theme.white}
              margintop={"0"}>
                <Link to='/autentificare'>
                  {t('header.login')}
                </Link>
            </CustomButton>
          : null}

          {isUserLogged() ?
            <Link to="/"
              onClick={() => logout(false)}
              style={{ 
                margin: 0,
                padding: '5px'
              }}>
              <Tooltip title={t('header.signout')}>
                <FontAwesomeIcon icon={solid('right-from-bracket')} style={{fontSize: theme.headerSizeIcons }}/>
              </Tooltip>
            </Link>
          : null }
        </div>
      <NavBarMobile />

    </div>
  );
};

export default NavBar;

